var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2679 7.28155C16.2679 3.26006 13.0547 0 9.09091 0C5.12714 0 1.91388 3.26006 1.91388 7.28155V11.699C0.821895 11.9239 0 12.9034 0 14.0777C0 15.4182 1.07109 16.5049 2.39234 16.5049H6.2201V17.0874C6.2201 18.696 7.5054 20 9.09091 20C10.6764 20 11.9617 18.696 11.9617 17.0874V16.5049H15.7895C17.1107 16.5049 18.1818 15.4182 18.1818 14.0777C18.1818 12.9034 17.3599 11.9239 16.2679 11.699V7.28155ZM15.7895 13.0097H2.39234C1.81099 13.0097 1.33971 13.4879 1.33971 14.0777C1.33971 14.6675 1.81099 15.1456 2.39234 15.1456H6.2201H11.9617H15.7895C16.3708 15.1456 16.8421 14.6675 16.8421 14.0777C16.8421 13.4879 16.3708 13.0097 15.7895 13.0097ZM14.9282 11.6505V7.28155C14.9282 4.01074 12.3148 1.35922 9.09091 1.35922C5.86705 1.35922 3.25359 4.01074 3.25359 7.28155V11.6505H14.9282ZM10.622 16.5049H7.55981V17.0874C7.55981 17.9453 8.24531 18.6408 9.09091 18.6408C9.93651 18.6408 10.622 17.9453 10.622 17.0874V16.5049Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.e89a520b5ce9987e03797dceb7e06ae0.svg";
export { ForwardRef as ReactComponent };